import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { BellRing, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FirmNotificationRecipientsCard = () => {
  const [candidates, setCandidates] = useState([]);
  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/firm-notification-recipients`)
      .then(res => { setCandidates(res.data.candidates); setSelected(res.data.selected); })
      .catch(() => {});
  }, []);

  const toggle = (id, checked) => setSelected(prev => (checked ? [...prev, id] : prev.filter(x => x !== id)));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/settings/firm-notification-recipients`, { ids: selected });
      toast.success('Bildirim alıcıları kaydedildi');
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'Kaydedilemedi');
    } finally { setSaving(false); }
  };

  return (
    <Card className="border-slate-200" data-testid="firm-recipients-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><BellRing className="h-5 w-5" />Firma Başvuru Bildirim Alıcıları</CardTitle>
        <CardDescription>Yeni firma kaydı, tekrar başvuru ve firmanın belge yüklemesi e-postaları seçtiğiniz kişilere gider. Hiç seçim yapılmazsa firma düzenleme yetkisi olan tüm adminlere gönderilir.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="rounded-lg border divide-y max-h-72 overflow-y-auto">
          {candidates.map(u => (
            <label key={u.id} className="flex items-center gap-3 px-3 py-2.5 cursor-pointer hover:bg-slate-50" data-testid={`firm-recipient-${u.id}`}>
              <Checkbox checked={selected.includes(u.id)} onCheckedChange={(c) => toggle(u.id, !!c)} data-testid={`firm-recipient-checkbox-${u.id}`} />
              <span className="text-sm font-medium text-slate-800">{u.name}</span>
              <span className="text-xs text-slate-500">{u.email}</span>
              {u.is_super_admin && <span className="ml-auto text-[10px] px-1.5 py-0.5 rounded bg-purple-100 text-purple-700">Süper Admin</span>}
            </label>
          ))}
          {candidates.length === 0 && <p className="text-sm text-slate-400 p-3">Uygun kullanıcı bulunamadı</p>}
        </div>
        <div className="flex items-center justify-between">
          <span className="text-xs text-slate-500" data-testid="firm-recipients-summary">{selected.length ? `${selected.length} kişi seçili` : 'Seçim yok: tüm yetkili adminler'}</span>
          <Button onClick={save} disabled={saving} className="bg-slate-900 hover:bg-slate-800" data-testid="firm-recipients-save">
            {saving && <Loader2 className="h-4 w-4 mr-1 animate-spin" />}Kaydet
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
